import React from "react";

const faqs = [
  {
    question: "What are Fly Ash Bricks?",
    answer:
      "Fly ash bricks are eco-friendly building materials made from fly ash, cement, and sand. They are strong, durable, and better for the environment than traditional clay bricks."
  },
  {
    question: "Why should I choose Anil Flyash Bricks?",
    answer:
      "We provide high-quality, machine-made bricks that are uniform in size, have excellent strength, and are delivered on time across Jharkhand."
  },
  {
    question: "Do you offer delivery service?",
    answer:
      "Yes, we deliver to multiple locations with affordable transportation costs. You can calculate delivery cost using our Delivery Calculator."
  },
  {
    question: "Can I get customized brick sizes?",
    answer:
      "Yes, we offer various brick and paver sizes. You can contact us for custom orders."
  },
  {
    question: "How can I place an order?",
    answer:
      "You can call us, message on WhatsApp, or use the Instant Quote form on our website."
  }
];

export default function FAQSection() {
  return (
    <section className="p-8 bg-gray-50 text-gray-900">
      <h2 className="text-2xl font-bold text-center mb-6">
        Frequently Asked Questions (FAQ)
      </h2>
      <div className="max-w-4xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <details
            key={index}
            className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
          >
            <summary className="font-semibold cursor-pointer">
              {faq.question}
            </summary>
            <p className="mt-2 text-gray-700">{faq.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
